export const calculateNetFee = (fee: number | string, platformShare: number | string, precision: number) => {
  const parsedFee = typeof fee === 'number' ? fee : Number.parseFloat(fee);
  const parsedPlatformShare = typeof platformShare === 'number' ? platformShare : Number.parseFloat(platformShare);

  const netFee = parsedFee - parsedFee * (parsedPlatformShare / 100);

  return netFee.toFixed(precision);
};
